import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { PaginationComponent } from "./pagination/pagination.component";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatTableModule } from "@angular/material/table";
import { MatSortModule } from "@angular/material/sort";
import { LoaderComponent } from "./loader/loader.component";
import { OtpDialogComponent } from "./otp-dialog/otp-dialog.component";
import { MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { RouterModule } from "@angular/router";
import { ConfirmationDialogComponent } from "./confirmation-dialog/confirmation-dialog.component";
import { FilterAccordionComponent } from "./filter-accordion/filter-accordion.component";
import { FilterSidebarComponent } from "./filter-sidebar/filter-sidebar.component";
import { FormsModule } from "@angular/forms";
import { SortFilterComponent } from "./sort-filter/sort-filter.component";
import { BreadcrumbComponent } from "./breadcrumb/breadcrumb.component";
import { CommonSearchComponent } from "./common-search/common-search.component";
import { HighlightPipe } from "../pipes/highlight.pipe";
import { CommonTableComponent } from "./common-table/common-table.component";
import { AdminCommonTableComponent } from "./admin-common-table/admin-common-table.component";
import { ToggleButtonComponent } from "./toggle-button/toggle-button.component";
import { MultiselectDropdownComponent } from "./multiselect-dropdown/multiselect-dropdown.component";
import { MatMenuModule } from "@angular/material/menu";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatSelectModule } from "@angular/material/select";
import { CommonAuthDialogComponent } from "./common-auth-dialog/common-auth-dialog.component";
import { SessionTimeoutDialogComponent } from "./session-timeout-dialog/session-timeout-dialog.component";
import { PanAlreadySearchedDialogComponent } from "./pan-already-searched-dialog/pan-already-searched-dialog.component";
import { CommonButtonComponent } from "./common-button/common-button.component";
import { UpdateCreditsModalComponent } from './update-credits-modal/update-credits-modal.component';
import { DownloadDocumentsDialogComponent } from './download-documents-dialog/download-documents-dialog.component';
import { ApiConfigModalComponent } from './api-config-modal/api-config-modal.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
  declarations: [
    PaginationComponent,
    LoaderComponent,
    OtpDialogComponent,
    ConfirmationDialogComponent,
    SortFilterComponent,
    CommonSearchComponent,
    FilterAccordionComponent,
    FilterSidebarComponent,
    HighlightPipe,
    CommonTableComponent,
    AdminCommonTableComponent,
    ToggleButtonComponent,
    MultiselectDropdownComponent,
    CommonAuthDialogComponent,
    SessionTimeoutDialogComponent,
    PanAlreadySearchedDialogComponent,
    CommonButtonComponent,
    UpdateCreditsModalComponent,
    DownloadDocumentsDialogComponent,
    ApiConfigModalComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatPaginatorModule,
    MatTableModule,
    MatSortModule,
    MatDialogModule,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatInputModule,
    RouterModule,
    BreadcrumbComponent,
    MatMenuModule,
    MatCheckboxModule,
    MatSelectModule,
    MatSlideToggleModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatTableModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    PaginationComponent,
    LoaderComponent,
    OtpDialogComponent,
    FilterAccordionComponent,
    FilterSidebarComponent,
    SortFilterComponent,
    BreadcrumbComponent,
    CommonSearchComponent,
    HighlightPipe,
    CommonTableComponent,
    AdminCommonTableComponent,
    ToggleButtonComponent,
    MultiselectDropdownComponent,
    SessionTimeoutDialogComponent,
    CommonButtonComponent,
  ],
})
export class SharedModule { }
